module.exports = __webpack_public_path__ + "img/2.94359bd6.png";